import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowDownToBracket,
  faAt,
  faFax,
  faFileInvoice,
  faGlobe,
  faMobile,
  faPhone,
  IconDefinition,
} from "@fortawesome/pro-light-svg-icons"
import { AlbaranReadingFiltersDtoProps } from "api/DTOs/AlbaranReadingFiltersDto"
import { PedidoReadingFiltersDtoProps } from "api/DTOs/PedidoReadingFiltersDto"
import { TipoFormaContactoType } from "api/Types/TipoFormaContacto"
import { formatCurrency } from "common/utils/currency"
import notification from "common/utils/notification"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { EstadoRevisionActual } from "features/Documentos/components/EstadoRevisionActual/EstadoRevisionActual"
import { TFunction } from "i18next"
import { nanoid } from "nanoid"
import { frontendDateFormat } from "utils/formatDate"

export const FORMAS_DE_CONTACTO = {
  EMAIL: 1,
  TELEFONO: 3,
  MOVIL: 2,
  FAX: 4,
  WEB: 5,
}

export const OPTIONS_DOC = {
  VENTA: 1,
  COMPRA: 2,
}

export const removeIsNewProperty = (items: $TSMigrationFixMe) => {
  return items.map((item: $TSMigrationFixMe) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isNew, ...rest } = item
    return rest
  })
}
export const findDifferentObjects = (
  values: $TSMigrationFixMe,
  data: $TSMigrationFixMe
) => {
  return values.filter((item: $TSMigrationFixMe) => {
    const element = data.find(
      (dataItem: $TSMigrationFixMe) => dataItem.id === item.id
    )

    return (
      element &&
      [
        "bic",
        "entidadBancariaId",
        "entidadBancariaNombre",
        "iban",
        "mandato",
        "principal",
      ].some((key) => element[key] !== item[key])
    )
  })
}

export const DEFAULT_CURRENCY_ABREVIATURE = "EUR"
export const DEFAULT_CURRENCY_SYMBOL = "€"

export const FORMAS_DE_CONTACTO_REV = {
  1: "Email",
  2: "Movil",
  3: "Telefono",
  4: "Fax",
  5: "Web",
}

export const FORMAS_DE_CONTACTO_ICONS: Record<
  TipoFormaContactoType,
  IconDefinition
> = {
  1: faAt,
  2: faMobile,
  3: faPhone,
  4: faFax,
  5: faGlobe,
}

export const OPTIONS_FACTURA_CONTACTO = (
  t: TFunction,
  { ventas = 0, compras = 0 }: { ventas: number; compras: number }
) => {
  return [
    {
      name: `${t("crear.factura.saleLabel")} (${ventas})`,
      value: 1,
    },
    {
      name: `${t("crear.factura.buyLabel")} (${compras})`,
      value: 2,
    },
  ]
}

export const OPTIONS_ALBARAN_CONTACTO = (
  t: TFunction,
  { ventas = 0, compras = 0 }: { ventas: number; compras: number }
) => {
  return [
    {
      name: `${t("crear.albaran.saleLabel")} (${ventas})`,
      value: 1,
    },
    {
      name: `${t("crear.albaran.buyLabel")} (${compras})`,
      value: 2,
    },
  ]
}
export const OPTIONS_PEDIDO_CONTACTO = (
  t: TFunction,
  { ventas = 0, compras = 0 }: { ventas: number; compras: number }
) => {
  return [
    {
      name: `${t("crear.pedido.saleLabel")} (${ventas})`,
      value: 1,
    },
    {
      name: `${t("crear.pedido.buyLabel")} (${compras})`,
      value: 2,
    },
  ]
}

export const OPTIONS_PRESUPUESTOS_CONTACTO = (
  t: TFunction,
  { ventas = 0, compras = 0 }: { ventas: number; compras: number }
) => {
  return [
    {
      name: `${t("crear.presupuesto.saleLabel")} (${ventas})`,
      value: 1,
    },
    {
      name: `${t("crear.presupuesto.buyLabel")} (${compras})`,
      value: 2,
    },
  ]
}

export const getDocumentTotalCount = async (
  queryState = "",
  nifKey: $TSMigrationFixMe,
  nifValue: $TSMigrationFixMe,
  idKey: $TSMigrationFixMe,
  idValue: $TSMigrationFixMe,
  filterFunction: $TSMigrationFixMe
) => {
  try {
    const result = await filterFunction({
      // @ts-expect-error TS(2698): Spread types may only be created from object types...
      ...queryState,
      [nifKey]: nifValue,
      [idKey]: idValue,
    })
    return result.totalCount
  } catch (error) {
    return 0
  }
}

export const createOptions = (
  label1: $TSMigrationFixMe,
  label2: $TSMigrationFixMe,
  saleTotalCount: $TSMigrationFixMe,
  buyTotalCount: $TSMigrationFixMe
) => {
  return [
    {
      name: (
        <p className='content-header-title tw-m-0'>
          {label1} (<span>{saleTotalCount || 0}</span>)
        </p>
      ),
      value: 1,
    },
    {
      name: (
        <p className='content-header-title tw-m-0'>
          {label2} (<span>{buyTotalCount || 0}</span>)
        </p>
      ),
      value: 2,
    },
  ]
}

export const COLUMNAS_ALBARANES_CONTACTOS = (
  t: TFunction,
  isVenta: boolean,
  handleDownloadPdf: (id: string, serie: string, t: TFunction) => void,
  handleConvertirDocumento: (
    rowData: AlbaranReadingFiltersDtoProps,
    finalType: string
  ) => void
) => {
  const columns = [
    {
      header: t("crear.albaran.tab.headerEmisionDate"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({ fechaEmision }: AlbaranReadingFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
      sortable: true,
      sortField: "fechaEmision",
    },
    {
      header: t("crear.albaran.tab.headerNumOrder"),
      field: "serie",
      key: "serie",
      sortable: true,
      sortField: "serie",
    },
    {
      header: t("crear.albaran.tab.headerState"),
      field: "estadoRevisionActual",
      key: "estadoRevisionActual",
      body: ({ estadoRevisionActual }: PedidoReadingFiltersDtoProps) => {
        return estadoRevisionActual
          ? EstadoRevisionActual(estadoRevisionActual)
          : ""
      },
      sortable: true,
      alignCol: "center",
      sortField: "estadoRevisionActual",
    },
    {
      header: t("crear.albaran.tab.headerImport"),
      field: "importe",
      key: "importe",
      className: "!tw-text-end",
      body: ({ importe }: PedidoReadingFiltersDtoProps) =>
        formatCurrency(importe),
      sortable: true,
      alignCol: "right",
      sortField: "importe",
    },

    {
      key: "opciones",
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: AlbaranReadingFiltersDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={
              !isVenta
                ? [
                    {
                      title: `${t("crear.factura.tab.downloadLabel")}`,
                      hasRedirect: true,
                      action: () => {
                        rowData.id &&
                          handleDownloadPdf(rowData.id, `${rowData.serie}`, t)
                      },
                      icon: faArrowDownToBracket,
                    },
                  ]
                : [
                    {
                      title: `${t("crear.factura.tab.downloadLabel")}`,
                      hasRedirect: true,
                      action: () => {
                        rowData.id &&
                          handleDownloadPdf(rowData.id, `${rowData.serie}`, t)
                      },
                      icon: faArrowDownToBracket,
                    },
                    {
                      title: `${t("crear.presupuesto.tab.convertirLabel")}`,
                      hasRedirect: false,
                      subMenu: [
                        {
                          title: `${t("asociateDoc.invoiceLabel")}`,
                          action: () =>
                            handleConvertirDocumento(
                              rowData,
                              TYPES_DOCUMENTOS.FACTURA
                            ),
                          icon: faFileInvoice,
                        },
                      ],
                    },
                  ]
            }
            position='right'
          />
        )
      },
    },
  ]
  return columns
}

export const OPTIONS_FORMAS_CONTACTO = (t: $TSMigrationFixMe) => [
  {
    label: `${t("perfilEmpresa.contact.types.tlfLabel")}`,
    value: FORMAS_DE_CONTACTO.TELEFONO,
  },
  {
    label: `${t("perfilEmpresa.contact.types.movileLabel")}`,
    value: FORMAS_DE_CONTACTO.MOVIL,
  },
  {
    label: `${t("perfilEmpresa.contact.types.emailLabel")}`,
    value: FORMAS_DE_CONTACTO.EMAIL,
  },
  {
    label: `${t("perfilEmpresa.contact.types.webLabel")}`,
    value: FORMAS_DE_CONTACTO.WEB,
  },
  {
    label: `${t("perfilEmpresa.contact.types.faxLabel")}`,
    value: FORMAS_DE_CONTACTO.FAX,
  },
]

export const FORMAS_CONTACTO = {
  EMAIL: 1,
  TELEFONO: 3,
  NONE: -1,
}

export const validateFormTabs = (formValues: $TSMigrationFixMe) => [
  {
    id: 0,
    key: "datosBasicos",
    invalid: !formValues.razonSocial,
  },
  {
    id: 1,
    key: "formasContacto",
    invalid: !(formValues.formasContacto || []).some(
      ({ tipoFormaContacto, contacto }: $TSMigrationFixMe) =>
        tipoFormaContacto === 1 && contacto
    ),
  },
]

// @ts-expect-error TS(7006): Parameter 'tipoFormaContacto' implicitly has an 'a...
export const emptyFormaDeContacto = (tipoFormaContacto, principal) => ({
  id: nanoid(),
  nombre: "",
  contacto: "",
  tipoFormaContacto,
  principal,
  isNew: true,
})

const contactFormTaxesFinder = (
  taxes = [],
  data: $TSMigrationFixMe,
  entity: $TSMigrationFixMe
) => {
  const isCliente = entity === "cliente"
  const entityTaxes = taxes?.filter(({ id }) => {
    const { repercutidoId, retenidoId } =
      data[`impuestos${isCliente ? "Venta" : "Compra"}`]

    return [repercutidoId, retenidoId].includes(id)
  })

  const entityTaxesGroups = entityTaxes.map(
    // @ts-expect-error TS(2339): Property 'tipoGrupoImpuesto' does not exist on typ...
    ({ grupoImpuesto }) => grupoImpuesto?.tipoGrupoImpuesto
  )

  return {
    [`${entity}Taxes`]: entityTaxes,
    [`${entity}TaxesGroups`]: entityTaxesGroups,
  }
}

const contactFormTaxesFinderReverse = (
  data: $TSMigrationFixMe,
  entity: $TSMigrationFixMe
) => {
  const isCliente = entity === "cliente"
  const impuestosIds = ["repercutidoId", "retenidoId"]

  return impuestosIds.reduce((accumulator, impuestoId) => {
    const taxGroup = impuestoId === "repercutidoId" ? 0 : 1
    const taxId = data[`${entity}Taxes`].find(
      ({ grupoImpuesto }: $TSMigrationFixMe) =>
        grupoImpuesto.tipoGrupoImpuesto === taxGroup
    )?.id

    return {
      ...accumulator,
      [`impuestos${isCliente ? "Venta" : "Compra"}`]: {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        ...accumulator[`impuestos${isCliente ? "Venta" : "Compra"}`],
        [impuestoId]: taxId,
      },
    }
  }, {})
}

export const contactFormTaxesMapper = (
  data: $TSMigrationFixMe,
  taxes = [],
  isPayload: $TSMigrationFixMe
) => {
  const entities = ["cliente", "proveedor"]

  return entities.reduce(
    (accumulator, entity) => ({
      ...accumulator,
      ...(isPayload
        ? contactFormTaxesFinderReverse(data, entity)
        : contactFormTaxesFinder(taxes, data, entity)),
    }),
    {}
  )
}

export const DEFAULT_FORMAS_CONTACTO = {
  principals: [],
  others: [],
}

export const contactoUpdateSuccessAlert = (t: $TSMigrationFixMe) => {
  notification.success({ body: t("notification.sucessGettingProperties") })
}
export const isContactoPage = (location: $TSMigrationFixMe) =>
  location.pathname.toLowerCase().includes("/contactos")
